import { isTauri } from './isTauri';
import { resourceKey } from './resourceKey';

/**
 * Rewrite a full resources URL to the `offlineres://` custom scheme so the Tauri
 * Rust handler serves it from local disk. The path after the host is the
 * resource key (origin-relative, query stripped) — identical to how the file
 * was stored, so the Rust handler re-encodes it to find the flat file.
 */
export function toOfflineUrl(url: string): string {
  return `offlineres://localhost${resourceKey(url)}`;
}

/**
 * Should resources route through the `offlineres://` scheme?
 *
 * In the BUILT Tauri app we ALWAYS route resources through it: the Rust handler
 * serves the local cache when present and otherwise proxies the real
 * (CloudFront-authenticated) URL via the shared cookie jar — so online and
 * offline both work, and the WKWebView never has to fetch CloudFront directly
 * (which it can't: no third-party cookies, CORS-blocked).
 *
 * Not in dev: `offlineres://` is blocked as insecure mixed-content when the page
 * is served from the external HTTPS dev server (`tauri dev`), and `pnpm dev` in
 * a browser has no Tauri handler. `import.meta.env.DEV` is true only under the
 * vite dev server. The `projectId` arg is kept for call-site compatibility.
 */
export function useServeOffline(_projectId?: string): boolean {
  if (import.meta.env.DEV) return false;
  return isTauri();
}
